// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ListPageContent$Showside from "../components/ListPageContent.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ListPageWithLazyContent$Showside from "./ListPageWithLazyContent.bs.js";
function ListPage(Props) {
  var scrollableContainerRef = Props.scrollableContainerRef;
  var drawerState = Props.drawerState;
  var anchorHookResult = Props.anchorHookResult;
  var children = Props.children;
  var match = EntrypointContext$Showside.use(undefined);
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, match$1.config.categories);
  var tmp = {
    scrollableContainerRef: scrollableContainerRef,
    isSidebarOpen: match.isSidebarOpen,
    isMobileFiltersOpen: match.isMobileFiltersOpen
  };
  if (activeCategory !== undefined) {
    tmp.activeCategory = Caml_option.valFromOption(activeCategory);
  }
  if (anchorHookResult !== undefined) {
    tmp.anchorHookResult = Caml_option.valFromOption(anchorHookResult);
  }
  var tmp$1 = {
    scrollableContainerRef: scrollableContainerRef,
    drawerState: drawerState,
    listPageContent: React.createElement(ListPageContent$Showside.make, tmp),
    children: children
  };
  if (anchorHookResult !== undefined) {
    tmp$1.anchorHookResult = Caml_option.valFromOption(anchorHookResult);
  }
  return React.createElement(ListPageWithLazyContent$Showside.make, tmp$1);
}
ListPage.displayName = "ListPage";
var make = ListPage;
export { make };
/* react Not a pure module */